<template lang="pug">
  #app
    b-loading(is-full-page :active.sync="isLoading")

    //- Форма авторизации
    template(v-if="!user")
      template(v-if="!isLoading")
        form-auth

    //- Приложение
    template(v-else)
      ui-navbar(:user="user" :breadcrumbs="breadcrumbs" @logout="logout")
        .navbar-item(v-if="countdown" )
          router-link(:to="{name:'app.tests', params:{id:testSession.test_id}}")
            ui-button.is-warning
              span Идет тестирование
              b-tag {{ testingTime }}

      ui-menubar(:menu="menubarItems" :back-link="breadcrumbs.length > 1")

      router-view

</template>

<script>
import api from '@/api';
import { mapGetters, mapMutations } from 'vuex';
import { ToastProgrammatic as Toast } from 'buefy';

let testingTimeout;

export default {
  name: 'app',

  data: () => ({
    isLoading: true,
    menubarItems: [
      {
        route: 'tasks',
        label: 'План',
        icon: 'calendar-check',
        attr: { class: 'is-blue' }, // is-marked
      },
      {
        route: 'app.tests',
        label: 'Тесты',
        icon: 'comment-question',
        attr: { class: 'is-purple' },
      },
      {
        route: 'docs',
        label: 'Материалы',
        icon: 'book',
        attr: { class: 'is-green' },
      },
      {
        route: 'control.tests',
        label: 'Тесты',
        icon: 'comment-question',
        attr: { class: 'is-purple' },
      },
      {
        route: 'control.reports',
        label: 'Отчеты',
        icon: 'chart-bar',
        attr: { class: 'is-orange' },
      },
      {
        route: 'control.users',
        label: 'Управление пользователями',
        icon: 'account-group',
        attr: { class: 'is-cyan' },
      },
      {
        route: 'control.settings',
        label: 'Настройки',
        icon: 'settings',
        attr: { class: 'is-red' },
      },
    ],
  }),

  watch: {
    testSession(session) {
      if (session && session.id) {
        this.timerTick();
        // Возврат к тестированию
        // this.$router.replace({ name: 'site.tests' });
      }
    },
  },

  computed: {
    ...mapGetters({
      user: 'user',
      breadcrumbs: 'breadcrumbs',
      countdown: 'getTestCountdown',
      testingTime: 'getTestingTime',
      testSession: 'getTestSession',
    }),
  },

  methods: {
    ...mapMutations(['setUser']),

    logout() {
      this.isLoading = true;
      api.logout().finally(() => {
        this.setUser(null);
        this.isLoading = false;
        this.$router.replace('/');
      });
    },

    timerTick() {
      if (testingTimeout) clearTimeout(testingTimeout);
      testingTimeout = setTimeout(() => {
        this.$store.commit('countdown');

        if (this.countdown > 0) {
          this.timerTick();
        } else {
          if (this.testSession.testing_time && !this.testSession.complete) {
            Toast.open({
              message: `Время тестирования истекло`,
              type: 'is-danger',
              // position: 'is-bottom-right',
            });
          }
        }
      }, 1000);
    },
  },

  created() {
    if (api.isTokenValid()) {
      this.isLoading = true;
      api
        .user()
        .then(({ data }) => {
          this.setUser(data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }

    this.$store.dispatch('loadTestSession');
  },

  // errorCaptured(err, vm, info) {
  //   console.log(`cat EC: ${err.toString()}\ninfo: ${info}`);
  //   return false;
  // },
};
</script>

<style lang="scss" src="./assets/app.scss"></style>
